import { EditedObstruction } from 'store/slices/ToolSlice/types';
import { createApiUrl, getToken } from '../../../../../../util';
import api from 'api/axiosInstance';

export async function patchObstructions(
	uuid: string, 
	addObstructions: Obstruction[], 
	deletedObstructionIDs: string[], 
	editedObsArray: EditedObstruction[])
{ 
	const token = getToken('Authorization');
	const config = {
		headers: {
			'Authorization': `Bearer ${token}`
		}
	};
	const sanitizedObstructions = addObstructions.map(
		({ shapeType, ...rest }) => rest
	);
	const body = {
		designUuid: uuid,
		addObstructions: sanitizedObstructions,
		deleteObstructions: deletedObstructionIDs,
		editedObstructions: editedObsArray,
	};

	const apiUrl = '/designs/obstructions';
	const { data } = await api.patch(createApiUrl(apiUrl), body, config);
	return data as RawSolarQueryData;
}